import { render, staticRenderFns } from "./PurchaseOptions.vue?vue&type=template&id=01f6d9a2"
import script from "./PurchaseOptions.vue?vue&type=script&lang=js"
export * from "./PurchaseOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports